const CTA = () => {
  return (
    <section className="py-20" style={{ backgroundColor: 'var(--bg-main2)' }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2
          className="text-3xl sm:text-4xl font-bold mb-6"
          style={{ color: 'var(--text-main)' }}
        >
          Ready to take control of your time tracking?
        </h2>
        <p
          className="text-xl mb-8 max-w-2xl mx-auto"
          style={{ color: 'var(--text-main2)' }}
        >
          Join individuals who have improved their productivity with TrakStr.
          Start tracking your time today with a self-hosted, privacy-focused
          solution.
        </p>
        <div className="flex justify-center">
          <button className="btn btn-primary btn-lg">Get Started - Free</button>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
          <div>
            <div
              className="text-3xl font-bold mb-2"
              style={{ color: 'var(--link-main)' }}
            >
              Self-Hosted
            </div>
            <div style={{ color: 'var(--text-main2)' }}>
              Complete Data Control
            </div>
          </div>
          <div>
            <div
              className="text-3xl font-bold mb-2"
              style={{ color: 'var(--link-main)' }}
            >
              ActivityWatch
            </div>
            <div style={{ color: 'var(--text-main2)' }}>
              Seamless Integration
            </div>
          </div>
          <div>
            <div
              className="text-3xl font-bold mb-2"
              style={{ color: 'var(--link-main)' }}
            >
              Privacy Focused
            </div>
            <div style={{ color: 'var(--text-main2)' }}>Secure Tracking</div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CTA
